export default __webpack_public_path__ + "static/media/Japan_Particle_0011_TenkoBall_3.bf5c764c.png";